module.exports = __webpack_public_path__ + "img/拖动演示-长版.950492ed.gif";